// @ts-nocheck

export default {
  SET_IS_REPEATER_STATE_ALLOWED: 'SET_IS_REPEATER_STATE_ALLOWED',
};
